module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-check-ae73ce3b.svg";